/* ============================================================
   MCH — SIGNAL · KABINA (virtual try-on)
   guided photo → /api/tryon (Gemini composite) → result
   Nothing stored; Turnstile-gated; graceful when backend off.
   ============================================================ */
(() => {
  'use strict';

  const modal = document.querySelector('.js-tro');
  const openers = [...document.querySelectorAll('[data-tryon-open]')];
  if (!modal || !openers.length) return;

  const cfg = JSON.parse(document.querySelector('[data-tryon-config]').textContent);
  const steps = [...modal.querySelectorAll('[data-step]')];
  const dots = [...modal.querySelectorAll('.tro__stepdot')];
  const fileInput = modal.querySelector('.js-tro-file');
  const previewImg = modal.querySelector('.js-tro-preview');
  const scanImg = modal.querySelector('.js-tro-scan-img');
  const resultImg = modal.querySelector('.js-tro-result');
  const goBtn = modal.querySelector('.js-tro-go');
  const remainEl = modal.querySelector('.js-tro-remaining');
  const tsBox = modal.querySelector('.js-tro-ts');
  const ORDER = ['guide', 'preview', 'working', 'result'];
  let photoDataUrl = null, tsToken = '', tsRendered = false;

  const errIn = (name) => modal.querySelector(`[data-step="${name}"] .js-tro-err`);
  function show(name) {
    steps.forEach((s) => { s.hidden = s.dataset.step !== name; });
    const idx = ORDER.indexOf(name);
    dots.forEach((d, i) => d.classList.toggle('is-done', i <= idx));
    modal.querySelectorAll('.js-tro-err').forEach((e) => { e.hidden = true; });
  }
  function showErr(step, msg) {
    show(step);
    const e = errIn(step);
    if (e) { e.textContent = msg; e.hidden = false; }
  }
  function fail(msg) {
    goBtn.disabled = false;
    showErr('preview', msg);
  }

  const open = () => {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    show('guide');
    loadTurnstile();
  };
  const close = () => {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  };
  openers.forEach((b) => b.addEventListener('click', open));
  modal.addEventListener('click', (e) => {
    if (e.target.closest('[data-overlay-close]') || e.target.classList.contains('tro__scrim')) close();
  });
  addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });

  function loadTurnstile() {
    if (!cfg.sitekey || tsRendered || !tsBox) return;
    const render = () => {
      if (tsRendered) return;
      tsRendered = true;
      window.turnstile.render(tsBox, {
        sitekey: cfg.sitekey,
        theme: 'light',
        callback: (t) => { tsToken = t; },
        'expired-callback': () => { tsToken = ''; },
      });
    };
    if (window.turnstile) return render();
    const s = document.createElement('script');
    s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?onload=__mchTroTs';
    window.__mchTroTs = render;
    document.head.appendChild(s);
  }

  /* client-side downscale to ≤1024px JPEG (EXIF dropped by re-encode) */
  const shrink = (file) => new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const max = 1024;
      const k = Math.min(1, max / Math.max(img.naturalWidth, img.naturalHeight));
      const c = document.createElement('canvas');
      c.width = Math.round(img.naturalWidth * k);
      c.height = Math.round(img.naturalHeight * k);
      c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
      resolve(c.toDataURL('image/jpeg', 0.88));
    };
    img.onerror = reject;
    img.src = url;
  });

  fileInput.addEventListener('change', async () => {
    const f = fileInput.files && fileInput.files[0];
    if (!f) return;
    try {
      photoDataUrl = await shrink(f);
      previewImg.src = photoDataUrl;
      show('preview');
    } catch {
      showErr('guide', 'Ne mogu da otvorim tu fotku. Probaj JPG ili PNG.');
    }
    fileInput.value = '';
  });

  modal.querySelectorAll('.js-tro-retake').forEach((b) => b.addEventListener('click', () => fileInput.click()));

  goBtn.addEventListener('click', async () => {
    if (!photoDataUrl) return;
    if (cfg.sitekey && !tsToken) {
      showErr('preview', 'Štrikliraj „nisam robot" pa idemo.');
      return;
    }
    goBtn.disabled = true;
    scanImg.src = photoDataUrl;
    show('working');
    try {
      const res = await fetch(cfg.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          photo: photoDataUrl,
          productImage: cfg.productImage,
          productTitle: cfg.productTitle,
          garments: cfg.garments || [],
          fit: cfg.fit || 'regular',
          kind: cfg.kind || 'majica',
          turnstileToken: tsToken,
        }),
      });
      if (res.status === 404 || res.status === 503) {
        throw new Error('Kabina još nije puštena u rad. Probaj za koji dan.');
      }
      const data = await res.json().catch(() => ({}));
      if (!res.ok || !data.ok) throw new Error(data.error || 'Proba trenutno ne radi. Probaj malo kasnije.');
      resultImg.src = data.image;
      if (remainEl) {
        remainEl.textContent = data.remaining > 0
          ? `Imaš još ${data.remaining} ${data.remaining === 1 ? 'probu' : 'probe'} danas.`
          : 'To je bila poslednja proba za danas.';
      }
      show('result');
    } catch (err) {
      fail(err.message || 'Nešto je puklo. Probaj ponovo.');
    } finally {
      if (window.turnstile && tsRendered) { try { window.turnstile.reset(); } catch {} }
      tsToken = '';
      goBtn.disabled = false;
    }
  });

  modal.querySelector('.js-tro-save').addEventListener('click', () => {
    const a = document.createElement('a');
    a.href = resultImg.src;
    a.download = 'mch-proba.png';
    a.click();
  });
  modal.querySelector('.js-tro-again').addEventListener('click', () => show('guide'));

  /* ---------------- story card (1080x1920) + share ---------------- */
  const loadImg = (src, cors) => new Promise((resolve, reject) => {
    const im = new Image();
    if (cors) im.crossOrigin = 'anonymous';
    im.onload = () => resolve(im);
    im.onerror = reject;
    im.src = src;
  });

  function roundedPath(ctx, x, y, w, h, r) {
    ctx.beginPath();
    ctx.moveTo(x + r, y);
    ctx.arcTo(x + w, y, x + w, y + h, r);
    ctx.arcTo(x + w, y + h, x, y + h, r);
    ctx.arcTo(x, y + h, x, y, r);
    ctx.arcTo(x, y, x + w, y, r);
    ctx.closePath();
  }

  /* fonts for the share frame (Graduate + Oswald), loaded on demand */
  async function ensureStoryFonts() {
    const wants = [
      ['Graduate', '400', cfg.fontGraduate],
      ['Oswald', '600', cfg.fontOswald],
    ];
    await Promise.all(wants.map(async ([fam, weight, url]) => {
      if (!url || document.fonts.check(`${weight} 20px ${fam}`)) return;
      try {
        const face = new FontFace(fam, `url(${url})`, { weight });
        await face.load();
        document.fonts.add(face);
      } catch {}
    }));
  }

  /* MCH varsity share frame, 1080x1920 (Story / TikTok / Shorts safe zones) */
  async function buildStoryCard() {
    const W = 1080, H = 1920;
    const MAROON = '#5A1319', FELT = '#7A1E24', DARKEST = '#3d0f14';
    const GOLD = '#E9A63A', CREAM = '#F6ECD6';
    const setLS = (px) => { try { ctx.letterSpacing = px + 'px'; } catch {} };

    await ensureStoryFonts();
    const photo = await loadImg(resultImg.src, false);

    const c = document.createElement('canvas');
    c.width = W; c.height = H;
    const ctx = c.getContext('2d');

    // frame matte
    ctx.fillStyle = MAROON;
    ctx.fillRect(0, 0, W, H);

    // slim varsity border (inset 26, gold 4px, r40)
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.35)'; ctx.shadowBlur = 22;
    roundedPath(ctx, 28, 28, W - 56, H - 56, 40);
    ctx.strokeStyle = GOLD; ctx.lineWidth = 4;
    ctx.stroke();
    ctx.restore();

    // top branding: MCH patch emblem + wordmark
    const pw = 472;
    let ph = 316;
    let patch = null;
    try { patch = await loadImg(cfg.storyPatch, true); ph = Math.round(pw * patch.naturalHeight / patch.naturalWidth); } catch {}
    const px = (W - pw) / 2, py = 50;
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.55)'; ctx.shadowBlur = 44; ctx.shadowOffsetY = 18;
    roundedPath(ctx, px, py, pw, ph, 22);
    ctx.fillStyle = FELT; ctx.fill();
    ctx.shadowColor = 'transparent';
    ctx.clip();
    if (patch) ctx.drawImage(patch, px, py, pw, ph);
    ctx.restore();
    if (!patch) {
      ctx.save();
      ctx.strokeStyle = GOLD; ctx.lineWidth = 6;
      roundedPath(ctx, px + 14, py + 14, pw - 28, ph - 28, 14);
      ctx.stroke();
      ctx.fillStyle = GOLD; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      ctx.font = '400 130px Graduate';
      ctx.fillText('MCH', W / 2, py + ph / 2 + 6);
      ctx.restore();
    }

    ctx.textAlign = 'center';
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.6)'; ctx.shadowBlur = 14; ctx.shadowOffsetY = 4;
    ctx.fillStyle = CREAM;
    ctx.font = '400 52px Graduate';
    setLS(9);
    ctx.textBaseline = 'top';
    ctx.fillText('MOMCHADIJA', W / 2 + 4.5, py + ph + 30);
    setLS(0);
    ctx.restore();

    // centered photo window (72 / 500 -> 936 x 915), cover-crop biased to the top
    const win = { x: 72, y: 500, w: 936, h: 915 };
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.5)'; ctx.shadowBlur = 54; ctx.shadowOffsetY = 22;
    roundedPath(ctx, win.x, win.y, win.w, win.h, 26);
    ctx.fillStyle = DARKEST; ctx.fill();
    ctx.shadowColor = 'transparent';
    ctx.clip();
    const k = Math.max(win.w / photo.naturalWidth, win.h / photo.naturalHeight);
    const sw = win.w / k, sh = win.h / k;
    const sx = (photo.naturalWidth - sw) / 2;
    const sy = (photo.naturalHeight - sh) * 0.18;   // keep heads in frame
    ctx.drawImage(photo, sx, sy, sw, sh, win.x, win.y, win.w, win.h);
    // inner maroon ring
    roundedPath(ctx, win.x + 1.5, win.y + 1.5, win.w - 3, win.h - 3, 25);
    ctx.strokeStyle = 'rgba(90,19,25,.9)'; ctx.lineWidth = 3;
    ctx.stroke();
    ctx.restore();
    // gold window border (6px, drawn inside the edge)
    roundedPath(ctx, win.x + 3, win.y + 3, win.w - 6, win.h - 6, 23);
    ctx.strokeStyle = GOLD; ctx.lineWidth = 6;
    ctx.stroke();

    // bottom branding: CTA pill + promo URL (inside platform safe zone)
    const urlCY = 1658, pillCY = 1550, pillH = 100;
    ctx.font = '400 46px Graduate';
    setLS(3);
    const ctaText = 'KUPI MCH MERCH';
    const pillW = ctx.measureText(ctaText).width + 132;
    setLS(0);
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.5)'; ctx.shadowBlur = 40; ctx.shadowOffsetY = 14;
    roundedPath(ctx, (W - pillW) / 2, pillCY - pillH / 2, pillW, pillH, pillH / 2);
    ctx.fillStyle = GOLD; ctx.fill();
    ctx.restore();
    roundedPath(ctx, (W - pillW) / 2 + 2, pillCY - pillH / 2 + 2, pillW - 4, pillH - 4, (pillH - 4) / 2);
    ctx.strokeStyle = 'rgba(90,19,25,.9)'; ctx.lineWidth = 4;
    ctx.stroke();
    ctx.fillStyle = MAROON;
    ctx.font = '400 46px Graduate';
    ctx.textBaseline = 'middle';
    setLS(3);
    ctx.fillText(ctaText, W / 2 + 1.5, pillCY + 2);
    setLS(0);

    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.6)'; ctx.shadowBlur = 12; ctx.shadowOffsetY = 3;
    ctx.fillStyle = CREAM;
    ctx.font = '600 38px Oswald';
    setLS(5);
    ctx.fillText('WWW.MOMCHADIJA.RS', W / 2 + 2.5, urlCY);
    setLS(0);
    ctx.restore();
    ctx.textBaseline = 'alphabetic';

    return new Promise((resolve) => c.toBlob(resolve, 'image/jpeg', 0.92));
  }
  window.MCHstoryCard = buildStoryCard;   // debug/testing hook

  const shareBtn = modal.querySelector('.js-tro-share');
  shareBtn && shareBtn.addEventListener('click', async () => {
    const label = shareBtn.innerHTML;
    shareBtn.disabled = true;
    shareBtn.textContent = 'Pravim story…';
    try {
      const blob = await buildStoryCard();
      const file = new File([blob], 'mch-story.jpg', { type: 'image/jpeg' });
      const payload = {
        files: [file],
        title: 'MCH',
        text: `Isprobano u MCH kabini ✦ ${cfg.shareUrl || 'https://momchadija.rs'}`,
      };
      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share(payload);
      } else {
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'mch-story.jpg';
        a.click();
        setTimeout(() => URL.revokeObjectURL(a.href), 4000);
        window.MCHtoast && window.MCHtoast('<span class="ok">✓</span> Story sačuvan, ubaci ga u Instagram ili TikTok');
      }
    } catch (err) {
      if (err && err.name !== 'AbortError') {
        window.MCHtoast && window.MCHtoast('<span class="err">✕</span> Deljenje nije uspelo, probaj ponovo.');
      }
    } finally {
      shareBtn.disabled = false;
      shareBtn.innerHTML = label;
    }
  });
})();
